
import BackAndForthNav from "@/components/navigation/BackAndForthNav.vue";
import BackAndForthFooter from "@/components/navigation/BackAndForthFooter.vue";
import BackAndForthFooter2 from "@/components/navigation/BackAndForthFooter2.vue";

import TheLayoutBase from "@/layouts/TheLayoutBase.vue";
import { getDefaultPartnerColor } from "@/lib/getDefaultPartnerColor";
import { ReportModule } from "@/store/modules/report.store";
import { Component, Prop, Vue } from "vue-property-decorator";
import { ReportScreenEnum } from "@/store/enum/partner/report-screen.enum";
import { ConfigModule } from "@/store/modules/config";

@Component({
  components: {
    TheLayoutBase,
    BackAndForthNav,
    BackAndForthFooter,
    BackAndForthFooter2
  }
})
export default class LayoutReportWithBanner extends Vue {
  @Prop({ default: true })
  private showFooter!: boolean;

  @Prop({ default: false })
  private isProgressDone!: boolean;

  @Prop({ default: true })
  private showProgress!: boolean;

  @Prop({ default: false })
  private showLoginButton!: boolean;

  @Prop({ default: false })
  private fluid!: boolean;

  async mounted() {
    this.checkFavIcon();
  }

  get partner() {
    return ReportModule.partner;
  }

  get logoUrl() {
    return ReportModule.partner.settings?.logoUrl;
  }

  get color() {
    return getDefaultPartnerColor();
  }

  get progress() {
    if (!this.showProgress) {
      return 0;
    }
    if (!this.isProgressDone) {
      const currentIndex = ReportModule.screenOder.indexOf(ReportModule.currentStep);
      return ((currentIndex + 1) / ReportModule.MAX_STEP) * 100;
    } else {
      return 100;
    }
  }

  get currentStep(): ReportScreenEnum {
    return ReportModule.currentStep;
  }

  get hasNext() {
    if (ReportModule.nextScreen) {
      return true;
    } else {
      return false;
    }
  }

  get hasPrev() {
    if (ReportModule.prevScreen) {
      return true;
    } else {
      return false;
    }
  }

  get nextAction() {
    return ReportModule.nextScreen;
  }

  get prevAction() {
    return ReportModule.prevScreen;
  }

  get isHeadless() {
    return ConfigModule.headless;
  }

  next() {
    const next = this.nextAction;
    ReportModule.setStep(next);
    this.$router.push({ path: `/${next}` });
  }

  previous() {
    const prev = this.prevAction;
    ReportModule.setStep(prev);
    this.$router.push({ path: `/${prev}` });
  }

  checkFavIcon() {
    const favIcon: any = document.querySelector("link[rel~='icon']");

    if (this.partner.settings?.reportSettings?.favIconUrl) {
      favIcon.href = this.partner.settings?.reportSettings?.favIconUrl;
      return;
    }

    if (this.partner.settings?.favIconUrl) {
      favIcon.href = this.partner.settings.favIconUrl;
      return;
    }

    favIcon.href = this.partner.settings?.websites[0]?.link + "/favicon.ico";
  }
}
